import Footer from '@/components/Footer'
import Header from '@/components/Header'
import { type ReactNode } from 'react'

type LayoutProps = {
  headerHTML: string
  footerHTML: string
  children: ReactNode
}

function Layout({ headerHTML, footerHTML, children }: LayoutProps) {
  return (
    <>
      <Header headerHTML={headerHTML} />
      {children}
      <Footer footerHTML={footerHTML} />
    </>
  )
}

export default Layout
